import React from 'react';
import axios from 'axios';
import { T } from '../../../../../../common/locale/translate';
import OfferItem from './offer_item';
import OffersNavigation from './offers_navigation';
import { urls } from '../../../../services/urls';
import {
  allInclusiveParams,
  exoticPlacesParams,
  fromGermanyParams,
  lastMinuteParams,
  paramsMap,
  placesWithoutPassportParams,
  withChildrenParams
} from './params';
import SkeletonOffers from './skeleton-offers';

const buttonTexts = {
  all_inclusive: `${T('all_inclusive')} - ${T('more_offers')}`,
  last_minute: `${T('last_minute')} - ${T('more_offers')}`,
  from_germany: `${T('from_germany')} - ${T('more_offers')}`,
  with_children: `${T('with_children')} - ${T('more_offers')}`,
  exotic_places: `${T('exotic_places')} - ${T('more_offers')}`,
  without_passport: `${T('without_passport')} - ${T('more_offers')}`
};

export default class OffersSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      offers: [],
      activeTab: null
    };
  }

  render() {
    return (
      <section className="offers">
        <h3>{T('check_special_offers')}</h3>
        <p>{T('chosen_by_our_experts')}</p>
        <span className="hyphen">{/* ornament */}</span>
        <article className="wrapper offers-wrapper">
          <OffersNavigation
            loadAllInclusiveOffers={this.loadAllInclusiveOffers.bind(this)}
            loadLastMinuteOffers={this.loadLastMinuteOffers.bind(this)}
            loadFromGermanyOffers={this.loadFromGermanyOffers.bind(this)}
            loadWithChildrenOffers={this.loadWithChildrenOffers.bind(this)}
            loadExoticPlacesOffers={this.loadExoticPlacesOffers.bind(this)}
            loadWithoutPassportOffers={this.loadWithoutPassportOffers.bind(
              this
            )}
            activeTab={this.state.activeTab}
            setActiveTab={tab => this.setState({ activeTab: tab })}
          />
          {this.state.loading ? (
            <SkeletonOffers />
          ) : (
            <div
              className={`${
                this.state.offers.length > 0 ? 'wrapper-photos' : ''
              }`}
            >
              {this.state.offers.map((special_offer, index) => (
                <OfferItem key={index} special_offer={special_offer} />
              ))}
              {this.state.offers.length > 0 && (
                <div className="button-wrapper">
                  <a
                    href={`/offers?${this.buildQueryString(
                      paramsMap[this.state.activeTab]
                    )}`}
                    title={buttonTexts[this.state.activeTab]}
                  >
                    <span>{buttonTexts[this.state.activeTab]}</span>
                  </a>
                </div>
              )}
            </div>
          )}
        </article>
      </section>
    );
  }

  buildQueryString(params) {
    const queryParams = { ...params };
    delete queryParams.limit;
    return new URLSearchParams(queryParams).toString();
  }

  loadAllInclusiveOffers() {
    this.setState({ activeTab: 'all_inclusive' });
    this.loadOffers(allInclusiveParams);
  }

  loadLastMinuteOffers() {
    this.setState({ activeTab: 'last_minute' });
    this.loadOffers(lastMinuteParams);
  }

  loadFromGermanyOffers() {
    this.setState({ activeTab: 'from_germany' });
    this.loadOffers(fromGermanyParams);
  }

  loadWithChildrenOffers() {
    this.setState({ activeTab: 'with_children' });
    this.loadOffers(withChildrenParams);
  }

  loadExoticPlacesOffers() {
    this.setState({ activeTab: 'exotic_places' });
    this.loadOffers(exoticPlacesParams);
  }

  loadWithoutPassportOffers() {
    this.setState({ activeTab: 'without_passport' });
    this.loadOffers(placesWithoutPassportParams);
  }

  loadOffers(payload) {
    document.querySelector('.default-offers').style = 'display: none;';
    this.setState({ loading: true });

    axios({
      method: 'get',
      url: urls['special_offers_list'],
      headers: {
        'Content-Type': 'application/json'
      },
      params: payload
    }).then(response => {
      this.setState({ loading: false, offers: response.data.offers_list });
    });
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/home/components/offers_section/offers.jsx